import { merge } from '../../utils/helpers';

var ImageEditorHandler = function ImageEditorHandler(uppy) {
  var fileTypeOptions = {
    'image/gif': {
      actions: {
        rotate: false,
        granularRotate: false
      }
    }
  };
  var editor = uppy.getPlugin('ImageEditor');
  var originalOpts = merge({}, editor.opts);

  var onStart = function onStart(file) {
    var optOverride = fileTypeOptions[file.type];

    if (optOverride && Object.keys(optOverride).length > 0) {
      editor.opts = merge(editor.opts, optOverride);
    }
  };

  var onFinish = function onFinish() {
    editor.opts = merge({}, originalOpts);
  };

  return {
    onStart: onStart,
    onFinish: onFinish
  };
};

export default ImageEditorHandler;